/** @format */

import { useQuery } from "@tanstack/react-query";
import service from "../utils/service";

const useCheckActiveSurvey = (enabled = true) => {
  const allSurvey = useQuery({
    queryKey: ["checkActiveSurvey"],
    queryFn: () => service.surveyExistence(),
    select: (data) => data.data,
    enabled
  });
  return allSurvey;
};

export default useCheckActiveSurvey;
